import { render, staticRenderFns } from "./pagebuilder-slide.vue?vue&type=template&id=e2a44ea0&scoped=true&"
import script from "./pagebuilder-slide.vue?vue&type=script&lang=js&"
export * from "./pagebuilder-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a44ea0",
  null
  
)

export default component.exports